// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../app/assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../app/assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../app/assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../app/assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../app/assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../app/assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../app/assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../app/assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../app/assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.Blocked_SignIn__L2MLQ .Blocked_blockedAccount__xLZ4M {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}

.Blocked_scroll__tpGgp::-webkit-scrollbar {
  height: 8px;
}
.Blocked_scroll__tpGgp::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.Blocked_scroll__tpGgp::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.Blocked_SignIn__L2MLQ {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.Blocked_SignIn__L2MLQ.Blocked_succecs__dUnlT .Blocked_alert__Q3rek {
  transform: translateX(-50%) translateY(0);
}
.Blocked_SignIn__L2MLQ .Blocked_blockedAccount__xLZ4M {
  background-color: rgba(255, 255, 255, 0.9);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
}
.Blocked_SignIn__L2MLQ .Blocked_blockedAccount__xLZ4M .Blocked_content__0\\+-3b {
  max-width: 366px;
  padding: 38px 59px;
  background-color: var(--bgColor);
  color: var(--mainColor);
  border: 1px solid var(--borderColor);
}
.Blocked_SignIn__L2MLQ .Blocked_blockedAccount__xLZ4M .Blocked_content__0\\+-3b p {
  text-align: center;
  font-size: 16px !important;
  line-height: 18px;
  font-family: inherit;
}
.Blocked_SignIn__L2MLQ .Blocked_blockedAccount__xLZ4M .Blocked_content__0\\+-3b button {
  display: block;
  width: calc(100% - 24px);
  height: 30px;
  margin: auto;
  margin-top: 20px;
  background-color: var(--secondaryColor);
  font-size: 12px;
  color: #fff;
  border: 1px solid var(--secondaryColor);
  cursor: pointer;
  font-family: inherit;
  transition: 0.5s;
}
.Blocked_SignIn__L2MLQ .Blocked_blockedAccount__xLZ4M .Blocked_content__0\\+-3b button:hover {
  background-color: transparent;
  color: var(--secondaryColor);
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/auth/pages/BLocked/Blocked.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;ADgDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;AC9CF;;ADiHE;EACE,WAAA;AC9GJ;ADiHE;EACE,kCAAA;AC/GJ;ADkHE;EACE,kCAAA;AChHJ;;AA9DA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAiEF;AA9DI;EACE,yCAAA;AAgEN;AA5DE;EAEE,0CAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AA6DJ;AA3DI;EACE,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,uBAAA;EACA,oCAAA;AA6DN;AA3DM;EACE,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,oBAAA;AA6DR;AA3DM;EACE,cAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,WAAA;EACA,uCAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AA6DR;AA3DQ;EACE,6BAAA;EACA,4BAAA;AA6DV","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.SignIn {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n\n  &.succecs {\n    .alert {\n      transform: translateX(-50%) translateY(0);\n    }\n  }\n  // Blocked Account Popup\n  .blockedAccount {\n    @extend %centeredHrVr;\n    background-color: rgba(#ffffff, 0.9);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9;\n\n    .content {\n      max-width: 366px;\n      padding: 38px 59px;\n      background-color: var(--bgColor);\n      color: var(--mainColor);\n      border: 1px solid var(--borderColor);\n\n      p {\n        text-align: center;\n        font-size: 16px !important;\n        line-height: 18px;\n        font-family: inherit;\n      }\n      button {\n        display: block;\n        width: calc(100% - 24px);\n        height: 30px;\n        margin: auto;\n        margin-top: 20px;\n        background-color: var(--secondaryColor);\n        font-size: 12px;\n        color: #fff;\n        border: 1px solid var(--secondaryColor);\n        cursor: pointer;\n        font-family: inherit;\n        transition: 0.5s;\n\n        &:hover {\n          background-color: transparent;\n          color: var(--secondaryColor);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SignIn": `Blocked_SignIn__L2MLQ`,
	"blockedAccount": `Blocked_blockedAccount__xLZ4M`,
	"scroll": `Blocked_scroll__tpGgp`,
	"succecs": `Blocked_succecs__dUnlT`,
	"alert": `Blocked_alert__Q3rek`,
	"content": `Blocked_content__0+-3b`
};
export default ___CSS_LOADER_EXPORT___;
